<template>
    <v-flex pa-0>
        <v-text-field prepend-inner-icon="attach_file"
                      v-model="filename" :label="label" :required="required"
                      @click.native="onFocus"
                      :disabled="disabled" ref="fileTextField"
                      readonly
                      box
        ></v-text-field>
        <input type="file" :accept="accept" :multiple="false" :disabled="disabled"
               ref="fileInput" @change="onFilePicked">
        </input>

    </v-flex>
</template>

<script>
    import AlertService from "@/helpers/AlertService";

    export default{
        name: "FileInputChallenge",
        props: {
            value: {
                type: [Array, String]
            },
            accept: {
                type: String,
                default: "*"
            },
            label: {
                type: String,
                default: "Please choose..."
            },
            required: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean, // not yet possible because of data
                default: false
            },
        },
        computed: {
        },
        created() {
            let i = 0;
            let list = this.accept.split(",");
            for(i=0; i<list.length; i++){
                this.listAcceptedExtention.push(list[i].slice(1))
            }
        },
        data(){
            return {
                filename: "",
                listAcceptedExtention: [],
            };
        },
        watch: {
            value(v){
                this.filename = v;
            }
        },
        mounted() {
            this.filename = this.value;
        },

        methods: {
            onFocus(){
                if (!this.disabled) {
                    //debugger;
                    this.$refs.fileInput.click();
                }
            },
            onFilePicked(e){
                const files = e.target.files
                const fr = new FileReader()

                if(files[0]){
                    if (files[0].size > 5000000) {
                        let alertOptions = {
                            type: "error",
                            message: "Please check file size no over 5 MB!",
                        };
                        AlertService.createAlert(alertOptions);
                    }
                    else{
                        fr.readAsDataURL(files[0])
                        fr.addEventListener('load', () => {
                            if(this.listAcceptedExtention.includes(files[0].name.split(".")[files[0].name.split(".").length - 1].toLowerCase())){
                                this.filename = files[0].name
                                this.$emit('update' , fr.result)
                            }
                        })
                    }

                }
            },
        }
    };
</script>

<style scoped>
    input[type=file] {
        position: absolute;
        left: -99999px;
    }
</style>